import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { DebtSaleAccountDetailsSuccessSelection } from 'shared/components/DebtSale/hooks/useDebtSaleAccountDetails';
import { useDebtSaleAction } from 'shared/components/DebtSale/hooks/useDebtSaleAction';
import DebtSaleFaqSection from 'shared/components/DebtSale/ProductDebtSoldScreen/DebtSaleFaqSection';
import Button from 'shared/components/vxl/Button/Button';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import theme from 'shared/styles/theme';

interface ProductDebtSoldContentProps {
  success: DebtSaleAccountDetailsSuccessSelection;
}

const ProductDebtSoldContent = ({ success }: ProductDebtSoldContentProps) => {
  const { handleDebtSaleAction } = useDebtSaleAction();

  const handlePaymentPortalPress = () => {
    void handleDebtSaleAction(success.paymentPortalButton.contactMethod.action);
  };

  return (
    <ScrollView
      style={styles.scroll}
      contentContainerStyle={styles.scrollContent}
      showsVerticalScrollIndicator={false}
    >
      <View style={styles.content}>
        <TitleLgText>{success.pageTitle}</TitleLgText>
        <BodyBaseText style={styles.subtitle}>{success.subtitle}</BodyBaseText>
        {success.sections.map((section) => (
          <DebtSaleFaqSection
            key={section.id}
            title={section.title}
            body={section.body}
          />
        ))}
      </View>
      <View style={styles.ctaBlock}>
        <Button
          label={success.paymentPortalButton.label}
          onPress={handlePaymentPortalPress}
          width="FULL"
        />
        <BodySmText style={styles.footnote}>{success.footnote}</BodySmText>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  scroll: {
    flex: 1,
  },
  scrollContent: {
    gap: theme.spacing.l,
    padding: theme.spacing.m,
  },
  content: {
    gap: theme.spacing.m,
  },
  subtitle: {
    color: theme.color.text.primary,
  },
  ctaBlock: {
    gap: theme.spacing.m,
  },
  footnote: {
    color: theme.color.text.secondary,
  },
});

export default ProductDebtSoldContent;
